export default "__VITE_ASSET__DRU0fA1x__"